import {AppState} from '../../configStore';

export const selectHasInitialScrollHappened = (state: AppState) => state.hasInitialScrollHappened;
